import { useEffect } from 'react';
import { API } from '@unboared/react';

import { SEASONAL_SHARED_KEY } from '~/config/seasonalTheme.config';
import { useSeasonalTheme } from '~/hooks/useSeasonalTheme';

/**
 * TV (enfant d'UnboaredGame) : diffuse aux téléphones le thème de saison actif (ou null),
 * déjà filtré ici (date, bar en mode animé, interrupteur du lieu). Le téléphone ne fait
 * que suivre : une TV restée sur l'ancien code ne diffuse rien → téléphone sans thème.
 * Clé partagée NOUVELLE (gotcha #232 : jamais changer la forme d'un message existant).
 */
export function SeasonalThemeHost({ clientID, mode }: { clientID: string; mode: string | undefined }) {
    const seasonal = useSeasonalTheme(clientID, mode);

    useEffect(() => {
        try {
            API.loadSharedProperty(API.getHostID(), SEASONAL_SHARED_KEY, seasonal);
        } catch {
            /* hôte pas encore prêt : l'état partagé est renvoyé à chaque (re)connexion de l'hôte */
        }
    }, [seasonal]);

    return null;
}
